// CSS Modules - component class name prefix: WorldWideList__

<template>
  <div :class="$style.container">
    <div :class="$style.selects">
      <div class="columns is-multiline">
        <div class="column is-half-tablet is-one-quarter-desktop">
          <FormSelect
            :hasFilter="false"
            v-model="regionSelectValue"
            :label="config.regionLabel"
            :options="regionSelectOptions"
            :initialOption="regionSelectValue"
            @input="updateCountries"
          />
        </div>
        <div class="column is-half-tablet is-one-quarter-desktop">
          <FormSelect
            :key="`countryKey-${componentKey}`"
            :hasFilter="false"
            v-model="countrySelectValue"
            :label="config.countryLabel"
            :options="countrySelectOptions"
            :initialOption="countrySelectValue"
            @input="updateContacts"
          />
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div
        :key="index"
        v-for="(result, index) in contacts"
        class="column is-half-tablet is-one-third-desktop"
      >
        <ListTeaser :result="result" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Button from "../Button/Button.vue";
import FormSelect from "../FormSelect/FormSelect.vue";
import ListTeaser from "../ListTeaser/ListTeaser.vue";
import { regionDataUrl } from "../../shared/globals";

export default {
  name: "WorldWideList",
  components: {
    Button,
    FormSelect,
    ListTeaser
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      componentKey: 0,
      apiData: null,
      contacts: [],
      regionSelectOptions: [],
      regionSelectValue: "",
      countrySelectOptions: [],
      countrySelectValue: ""
    };
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    getContacts(url) {
      axios
        .get(url)
        .then(response => (this.contacts = response.data.contacts))
        .catch(error => console.log(error));
    },
    updateContacts(value) {
      this.countrySelectValue = value;

      for (let region of this.apiData.regions) {
        if (region.name === this.regionSelectValue) {
          for (let country of region.countries) {
            if (country.name === value) {
              this.getContacts(country.contacts);
            }
          }
        }
      }
    },
    initApiData(data) {
      this.apiData = data;
      this.regionSelectValue = this.config.currentRegion;
      this.countrySelectValue = this.config.currentCountry;

      for (let region of this.apiData.regions) {
        this.regionSelectOptions.push(region.name);

        if (region.name === this.config.currentRegion) {
          for (let country of region.countries) {
            this.countrySelectOptions.push(country.name);

            if (country.name === this.config.currentCountry) {
              this.getContacts(country.contacts);
            }
          }
        }
      }
      this.forceRerender();
    },
    updateCountries(value) {
      this.regionSelectValue = value;

      for (let region of this.apiData.regions) {
        if (region.name === value) {
          this.countrySelectValue = region.countries[0].name;
          this.countrySelectOptions.length = 0;

          for (let country of region.countries) {
            this.countrySelectOptions.push(country.name);
          }
          this.getContacts(region.countries[0].contacts);
        }
      }
      this.forceRerender();
    }
  },
  mounted() {
    let dataUrl = "";
    window.regionDataUrl
      ? (dataUrl = window.regionDataUrl)
      : (dataUrl = regionDataUrl);
    axios
      .get(dataUrl)
      .then(response => this.initApiData(response.data))
      .catch(error => console.log(error));
  }
};
</script>

<style module lang="scss">
@import "./WorldWideList.scss";
</style>
